
import { useState, useEffect } from 'react';

export default function ContactHero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="relative min-h-[60vh] flex items-center overflow-hidden bg-[#0D0D0D]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20creative%20agency%20office%20interior%20workspace%20in%20Kampala%20Uganda%20with%20warm%20ambient%20lighting%20contemporary%20furniture%20open%20plan%20design%20professional%20environment%20with%20large%20windows%20overlooking%20green%20tropical%20landscape%20warm%20teal%20and%20orange%20accent%20colors%20cinematic%20wide%20angle%20photography&width=1920&height=900&seq=contact-hero-bg-001&orientation=landscape"
          alt="Asili Visuals Office"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D] via-[#0D0D0D]/80 to-[#0D0D0D]/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-transparent to-[#0D0D0D]/70"></div>
      </div>

      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(#038C7F 1px, transparent 1px), linear-gradient(90deg, #038C7F 1px, transparent 1px)',
            backgroundSize: '50px 50px',
          }}
        ></div>
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none hidden md:block">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              width: `${2 + Math.random() * 3}px`,
              height: `${2 + Math.random() * 3}px`,
              backgroundColor: i % 2 === 0 ? '#038C7F' : '#F2780C',
              opacity: 0.3,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `contactFloat ${6 + Math.random() * 8}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          ></div>
        ))}
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16">
        <div
          className={`transition-all duration-1000 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#038C7F]/20 border border-[#038C7F]/30 rounded-full mb-6">
            <span className="w-2 h-2 bg-[#038C7F] rounded-full animate-pulse"></span>
            <span className="text-[10px] font-bold text-[#038C7F] uppercase tracking-wider">
              Get In Touch
            </span>
          </div>

          <h1 className="mb-5">
            <div className="overflow-hidden">
              <div
                className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.9] tracking-tighter transition-all duration-700 delay-100 ${
                  isLoaded ? 'translate-y-0' : 'translate-y-full'
                }`}
              >
                Let&apos;s Start a
              </div>
            </div>
            <div className="overflow-hidden mt-1">
              <div
                className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-[0.9] tracking-tighter transition-all duration-700 delay-200 ${
                  isLoaded ? 'translate-y-0' : 'translate-y-full'
                }`}
              >
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#038C7F] via-[#05a99a] to-[#F2780C]">
                  Conversation
                </span>
              </div>
            </div>
          </h1>

          <div
            className={`flex items-start gap-3 mb-6 transition-all duration-700 delay-300 ${
              isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="w-12 h-[2px] bg-gradient-to-r from-[#038C7F] to-[#F2780C] mt-2.5 flex-shrink-0"></div>
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed max-w-lg">
              Whether you need a full brand overhaul, a cinematic production, or a strategic
              outdoor campaign — we&apos;re ready to bring your vision to life across East Africa.
            </p>
          </div>

          <div
            className={`flex flex-wrap items-center gap-6 sm:gap-10 transition-all duration-700 delay-500 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
            }`}
          >
            {[
              { icon: 'ri-time-line', label: 'Response within 24hrs', color: '#038C7F' },
              { icon: 'ri-chat-smile-3-line', label: 'Free Consultation', color: '#F2780C' },
              { icon: 'ri-shield-check-line', label: 'No Obligation Quote', color: '#038C7F' },
            ].map((item, idx) => (
              <div key={idx} className="flex items-center gap-2">
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${item.color}20` }}
                >
                  <i className={item.icon} style={{ color: item.color }}></i>
                </div>
                <span className="text-xs text-gray-400 font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Use dangerouslySetInnerHTML to inject raw CSS and avoid JSX parsing errors */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes contactFloat {
              0%, 100% { transform: translateY(0px); opacity: 0.3; }
              50% { transform: translateY(-20px); opacity: 0.6; }
            }
          `,
        }}
      />
    </section>
  );
}
